type PresetAttributes = {
  slug?: string;
  category?: string;
};

const parsePresetAttributes = (input?: string): PresetAttributes => {
  if (!input) return {};
  return {
    slug: input.match(/\bslug:\s*([^,]+)/)?.[1]?.trim(),
    category: input.match(/\bcategory:\s*([^,]+)/)?.[1]?.trim(),
  };
};

export default parsePresetAttributes;
